import { dcpcApi } from './dcpcApi';

const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    // getDataValue: builder.query({
    //   query: (valueObjectId) => ({
    //     url: `datavalue/actual/${valueObjectId}`,
    //   }),
    // }),

    getDataValue: builder.query({
      query: (valueObjectId) => ({
        url: `datavalue/actual/${valueObjectId}/witholdvalues`,
      }),
    }),
    pullDirtyValuesByDsIdAndTimeAndMeteocodes: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body,
        url: 'datavalues/table',
      }),
    }),

    updateDataValueTs: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body,
        url: '/dv-time-series/',
      }),
    }),
  }),
});

export const {
  useGetDataValueQuery,
  usePullDirtyValuesByDsIdAndTimeAndMeteocodesMutation,
  useUpdateDataValueTsMutation,
} = api;
